import { connect } from "react-redux";
import AgentAIFormComponent from "../../Components/AgentAI/AgentAIFormComponent";
import { setAgentAIs } from "../../Redux/Actions/AgentAIActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  st_AgentAIs: state.reducer.AGENT_AIS,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  CALL_FLOWS: state.reducer.CALL_FLOWS,
  QUEUES: state.reducer.QUEUES,
});

const mapDispatchToProps = (dispatch) => ({
  setAgentAIs: (agentAIs) => dispatch(setAgentAIs(agentAIs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AgentAIFormComponent);
